
/** Document events */

export const DOC_OPEN_SUCCESS = 'ev-doc-open-success';
export const DOC_OPEN_FAILED  = 'ev-doc-open-Failed';
export const DOC_MODIFIED     = 'ev-doc-modified';
export const DOC_BEFORE_OPEN     = 'ev-doc-before-open';
export const DOC_ACTIVATE     = 'ev-doc-activate';
export const DOC_SAVED        = 'ev-doc-saved';

export const LABEL_TOOL_START    = 'ev-label-tool-start';
export const LABEL_TOOL_END      = 'ev-label-tool-end';
export const LABEL_TOOL_CANCELED = 'ev-label-tool-canceled';

/** User events */
export const USER_SIGN_IN  = 'ev-user-sign-in';
export const USER_SIGN_OUT = 'ev-user-sign-out';
export const USER_MESSAGE_CALLBACK = 'ev-user-message-callback';



/** Page Name */
/** once */
export const PAGE_HOME     = 'page-home';
export const PAGE_MY_FILE  = 'page-files';
export const PAGE_REVIEW   = 'page-review';
export const PAGE_ANALYSIS = 'page-analysis';
export const PAGE_DRAFT    = 'page-draft';

export const EVENT_LIST = [
  DOC_OPEN_SUCCESS,
  DOC_OPEN_FAILED,
  DOC_MODIFIED,

  USER_SIGN_IN, 
  USER_SIGN_OUT,
  USER_MESSAGE_CALLBACK,
  
]